import { useState } from 'react';

/**
 * Tier description block for ticket cards. Preserves the writer's line breaks
 * (so every bullet / rule sits on its own line instead of getting compressed
 * into a wall of text), and collapses anything longer than the threshold
 * behind a "Read more" toggle so short tiers stay compact and long ones
 * don't blow out the card height.
 *
 * Threshold defaults to 180 chars — roughly two lines on desktop, three on
 * mobile — which matched the "cramped / cut-out" pain points from the
 * feedback thread.
 */
export default function TierDescription({ text, threshold = 180 }) {
  const [expanded, setExpanded] = useState(false);
  const value = (text || '').trim();
  if (!value) return null;

  const needsToggle = value.length > threshold;
  const shown = expanded || !needsToggle ? value : value.slice(0, threshold).trimEnd() + '…';

  return (
    <div className="mt-2">
      <p className="text-zinc-400 text-sm leading-relaxed whitespace-pre-line" data-testid="tier-description">
        {shown}
      </p>
      {needsToggle && (
        <button
          type="button"
          onClick={(e) => {
            // Prevent the parent tier <button> from stealing the click
            e.stopPropagation();
            e.preventDefault();
            setExpanded((v) => !v);
          }}
          className="mt-1 font-mono text-[10px] tracking-widest text-[#B5FF00] hover:text-white transition-colors"
          data-testid="tier-description-toggle"
        >
          {expanded ? 'SHOW LESS' : 'READ MORE'}
        </button>
      )}
    </div>
  );
}
